var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Event, Property } from '@syncfusion/ej2-base';
/**
 * Defines the ribbon checkbox item.
 */
export class RibbonCheckBoxSettings extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of checkbox.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property(false)
], RibbonCheckBoxSettings.prototype, "checked", void 0);
__decorate([
    Property('')
], RibbonCheckBoxSettings.prototype, "cssClass", void 0);
__decorate([
    Property('')
], RibbonCheckBoxSettings.prototype, "label", void 0);
__decorate([
    Property('After')
], RibbonCheckBoxSettings.prototype, "labelPosition", void 0);
__decorate([
    Property({})
], RibbonCheckBoxSettings.prototype, "htmlAttributes", void 0);
__decorate([
    Event()
], RibbonCheckBoxSettings.prototype, "created", void 0);
__decorate([
    Event()
], RibbonCheckBoxSettings.prototype, "change", void 0);
